<template>
  <!-- <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
   
<Form2></Form2>
    </v-main>
  </v-app> -->

<!-- <v-app>
  <v-navigation-drawer app   class=" accent-4"
      dark
      permanent>
  <v-list-item>
        <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>John Leider</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
  </v-navigation-drawer>

  <v-app-bar app>

  </v-app-bar>


  <v-main>


    <v-container fluid>

<FormViewRun></FormViewRun>

    </v-container>
  </v-main>

  <v-footer app>

  </v-footer>
</v-app> -->
<div style="background-color: rgb(240, 235, 248);">
     <router-view></router-view>
</div>
   
</template>

<script>
//import HelloWorld from './components/HelloWorld';



//import FormRenderer from './components/FormRenderer.vue';
import FormChat from './components/FormChat.vue';
import form from './plugins/fieldTemplates';

export default {
  name: 'App',

  components: {
    //FormChat,
     //Form2

  },

  data: () => ({
    form,
     drawer: null,
        items: [
          { title: 'Home', icon: 'mdi-view-dashboard' },
          { title: 'About', icon: 'mdi-forum' },
        ],
    //
  }),
};
</script>
<style scoped>

</style>